import * as Request from '../Request';

const Project = {
  // 租户列表
  tenantList: (data) => {
    return Request.post('/tenant/list', data);
  },
  // 新增
  addTenant: (data) => {
    return Request.post('/tenant/save', data);
  },
  // 校验
  checkTenant: (data) => {
    return Request.postQuery('/tenant/check', data);
  },
  // 编辑
  updateTenant: (data) => {
    return Request.put('/tenant/update', data);
  },
  // 删除
  delTenant: (data) => {
    return Request.delBody('/tenant/delete', data);
  },
  // 租户系统列表
  systemList: (data) => {
    return Request.get('/tenant/product/list', data);
  },
  // 更新租户系统配置
  systemUpdate: (data) => {
    return Request.put('/tenant/product/update', data);
  },
  systemUpdatePwd: (data) => {
    return Request.put('/tenant/update/pwd', data);
  },
  // 重置租户密码
  resetPwd: (data) => {
    return Request.put('/tenant/product/resetPwd', data);
  },
  // 系统设置
  sysSetting: (data) => {
    return Request.put('/tenant/product/module', data)
  },
  // 复制登录信息（登录地址/超管账号/默认密码，一般租户与集团通用）
  loginInfo: (data) => {
    return Request.get('/tenant/loginInfo', data);
  },
  // 初始化租户（模块菜单/添加员工/隐患默认规则，一般租户与集团通用）
  initTenant: (data) => {
    return Request.post('/tenant/init', data);
  }
  // // 上传公司logo
  // uploadLogo: (data) => {
  //   return Request.post('/sys/user/logo/upload', data);
  // },

  // // 详情
  // accountInfo: (data) => {
  //   return Request.get('/sys/user/info', data);
  // },
  // // 租户自己的系统列表
  // mySystemList: (data) => {
  //   return Request.get('/sys/user/application/listCurrent', data);
  // },
  // // 租户人员系统配置
  // systemUserUpdate: (data) => {
  //   return Request.post('/tenant/user/application/role/update', data);
  // },
  // // 查询租户操作日志
  // logList: (data) => {
  //   return Request.post('/sys/user/log/list', data);
  // },
  // // 租户系统配置
  // systemUpdateByUser: (data) => {
  //   return Request.post('/tenant/user/application/update', data);
  // },
  // // 查询租户操作日志
  // logListByUser: (data) => {
  //   return Request.post('/tenant/user/log/list', data);
  // }
}
export default Project
